import React, { useState, useEffect, useContext } from 'react';
import PubSub from 'pubsub-js'
import { useImmer } from 'use-immer';
import { useHistory, useLocation } from "react-router-dom";
import { Button, Card, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { CustomerContext } from '../../contexts/CustomerContext';
import { AuthContext } from '../../contexts/AuthContext';
import { ConditionalRender } from '../../controls/formControls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faChevronCircleRight } from "@fortawesome/free-solid-svg-icons"
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { CustomerWorksheetPrint } from '..';
import ResultCountDisplay from '../../controls/table/ResultCountDisplay';

const CustomerCodingEvents = (props) => {
    const [isCustomerAdmin, setIsCustomerAdmin] = useState();
    const queueContext = useContext(CustomerContext);
    const authContext = useContext(AuthContext);
    const small = props.small ? true : false
    const history = useHistory();

    useEffect(() => {
        var isAdmin = authContext.hasPermission(authContext.claims.canCrudCustomerCodingQueue, authContext.claimValues.createReadUpdateDelete);
        setIsCustomerAdmin(isAdmin);
        queueContext.getCodingEvents();
    }, [])

    const codingEventCreatedCallback = (id) => {
        queueContext.hideModal();
        queueContext.getCodingEvents();
        // forward to coding event.
        if (id != undefined && id > 0) {
            history.push(`/customer/queue/${id}`)
        }
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Coding/Review Item</div>
                <div className="card-btn-group">
                    <ConditionalRender visible={queueContext.filtered}>
                        <Button variant="secondary" size="sm" onClick={() => queueContext.resetFilters()}>Clear Filters</Button>
                    </ConditionalRender>
                    <ConditionalRender visible={isCustomerAdmin}>
                        <Button variant="primary" size="sm" onClick={() => queueContext.showModal({
                            open: true,
                            size: 'lg',
                            closeModal: queueContext.hideModal,
                            onSaveCallback: codingEventCreatedCallback,
                        }, 'createCustomerEvent')}>Create New</Button>
                    </ConditionalRender>
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">

                <CustomerCodingEventsTable small={small}>
                </CustomerCodingEventsTable>
            </Card.Body>
        </Card>
    )
}

export default CustomerCodingEvents;


const CustomerCodingEventsTable = (props) => {

    //const [currentPage, setCurrentPage] = useImmer(0);
    const [descSearchText, setDescSearchText] = useImmer([]);

    const queueContext = useContext(CustomerContext);
    const location = useLocation();

    const handlePage = (page) => {
        if (queueContext.currentPage !== page.selected) {
            queueContext.pageResults(page.selected);
        }
        window.scrollTo(0, 0);
    }

    const changeFilterIntInput = (event) => {
        const target = event.target;
        const value = isNaN(target.value) ? 0 : parseInt(target.value);
        const name = target.name;
        queueContext.setFilterValue(name, value);
    }

    const changeFilterInput = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        if (name === 'searchText') {
            setDescSearchText(value);
            if (value.length > 3) {
                queueContext.setFilterValue(name, value);
            } else if (queueContext.filters.searchText.length > 0) {
                queueContext.setFilterValue(name, '');
            }
        } else {
            queueContext.setFilterValue(name, value);
        }
    }

    return (
        <>
            {/*JSON.stringify(queueContext.codingEvents[0], null, 2)*/}
            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                <thead>
                    <ConditionalRender visible={!props.small}>
                        <tr>
                            <th>
                                <Form.Control
                                    type="numeric"
                                    value={queueContext.filters.searchId > 0 ? queueContext.filters.searchId : ''}
                                    style={{ width: "56px" }}
                                    className="form-control borderless-control"
                                    name="searchId" id="searchId"
                                    size="sm"
                                    placeholder="Id"
                                    onChange={changeFilterIntInput} />
                            </th>
                            <th>
                                <Form.Control value={descSearchText}
                                    className="borderless-control"
                                    name="searchText" id="searchText"
                                    size="sm" placeholder="Description"
                                    onChange={changeFilterInput} />
                            </th>
                            <th>Clinician</th>
                            <th>
                                <ConditionalRender visible={queueContext.refData.accounts.length > 2}>
                                    <Form.Control as="select"
                                        value={queueContext.filters.accountId}
                                        className="borderless-control"
                                        name="accountId" id="accountId"
                                        size="sm"
                                        onChange={changeFilterIntInput}>
                                        {
                                            queueContext.refData.accounts?.map((acc) => {
                                                return <option key={acc.id} value={acc.id}>{queueContext.filters.accountId === acc.id ? "Account: " + acc.name : acc.name}</option>
                                            })
                                        }
                                        </Form.Control>
                                </ConditionalRender>
                                <ConditionalRender visible={queueContext.refData.accounts.length <= 2}>
                                    Account Name
                                </ConditionalRender>
                            </th>
                            <th>
                                <Form.Control as="select"
                                    value={queueContext.filters.requestedServiceId}
                                    className="borderless-control"
                                    name="requestedServiceId" id="requestedServiceId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.requestedServiceRefData?.map((service) => {
                                            return <option key={service.id} value={service.id}>{queueContext.filters.requestedServiceId === service.id ? "Service: " + service.name : service.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>LOB</th>
                            <th>
                                <Form.Control as="select"
                                    className="borderless-control"
                                    value={queueContext.filters.eventPriorityId}
                                    name="eventPriorityId"
                                    id="eventPriorityId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.eventPriorityRefData.map((priority) => {
                                            return <option key={priority.id} value={priority.id}>{priority.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>
                                Cust Priority
                            </th>
                            <th>Due By</th>
                            <th className={queueContext.filters.showMyQueue ? "d-none" : ""}>
                                Assigned To
                    </th>
                            <th className="no-padding-td">
                                <Form.Control as="select"
                                    className="borderless-control"
                                    value={queueContext.filters.statusId}
                                    name="statusId" id="statusId"
                                    size="sm"
                                    onChange={changeFilterIntInput}>
                                    {
                                        queueContext.refData.statusRefData.map((status) => {
                                            return <option key={status.id} value={status.id}>{queueContext.filters.statusId === status.id ? "Status: " + status.name : status.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th className="table-fit"></th>
                        </tr>
                    </ConditionalRender>
                    <ConditionalRender visible={props.small}>
                        <tr className={"d-none d-md-table-row d-lg-none"}>
                            <th>Id</th>
                            <th>Description</th>
                            <th>Clinician</th>
                            <th>Account Name</th>
                            <th>Service</th>
                            <th>LOB</th>
                            <th>Priority</th>
                            <th>Cust Priority</th>
                            <th>Due By</th>
                            <th>Assigned To</th>
                            <th className="no-padding-td">Status</th>
                            <th className="table-fit"></th>
                        </tr>
                    </ConditionalRender>
                </thead>
                <tbody>
                    {
                        queueContext.codingEvents.map((event, i) =>
                            <tr key={event.id}>
                                <td>{event.id}</td>
                                <td style={{ width: "300px" }}>{event.description.length > 80 ? event.description.substring(0, 80) + ' ...' : event.description}</td>
                                <td>{event.clinicianName}</td>
                                <td className={queueContext.filters.showCustomerQueue ? "d-none" : ""}>{event.customerAccountName}</td>
                                <td>{event.serviceRequestName}</td>
                                <td>{event.lineOfBusinessName}</td>
                                <td>{event.eventPriorityName}</td>
                                <td>{event.customerPriorityName}</td>
                                <td>{event.dueBy != null ? moment(event.dueBy).format('MM/DD/YYYY h:mm a') : 'Pending'}</td>
                                <td className={queueContext.filters.showMyQueue ? "d-none" : ""}>{event.assignedToName}</td>
                                <td>{event.statusName}</td>
                                <td className="table-fit">
                                    {
                                        event.id != undefined ?
                                            <LinkContainer to={'/customer/queue/' + event.id + '?returnUrl=' + encodeURIComponent(location.pathname)}>
                                                <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon givemethefinger" />
                                            </LinkContainer> : null
                                    }
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
            <ResultCountDisplay className="border-top"
                currentPage={queueContext.filters.currentPage}
                pageSize={queueContext.filters.take}
                currentResultCount={queueContext.codingEvents?.length} totalResults={queueContext.refData.totalRecords} />
            {
                queueContext.refData.totalRecords > queueContext.filters.take ?
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        //padding: 20,
                        boxSizing: 'border-box',
                        width: '100%',
                    }}>
                        <ReactPaginate
                            activeClassName={'pagination-item pagination-active '}
                            breakClassName={'pagination-item pagination-break-me '}
                            breakLabel={'...'}
                            containerClassName={'pagination-pagination'}
                            disabledClassName={'pagination-disabled-page'}
                            marginPagesDisplayed={2}
                            nextClassName={'pagination-item pagination-next '}
                            nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                            onPageChange={handlePage}
                            forcePage={queueContext.filters.currentPage}
                            pageCount={Math.ceil(queueContext.refData.totalRecords / queueContext.filters.take)}
                            pageClassName={'pagination-item pagination-page '}
                            pageRangeDisplayed={2}
                            previousClassName={'pagination-item pagination-previous'}
                            previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                        />
                    </div> : null
            }
        </>
    )
}

export { CustomerCodingEventsTable };